import { Sprout } from "lucide-react";

export default function Marquee({ items }) {
  const row = (ariaHidden) => (
    <div className="flex shrink-0 items-center" aria-hidden={ariaHidden || undefined}>
      {items.map((item, i) => (
        <span key={i} className="flex items-center">
          <span className="font-serif italic text-lg sm:text-2xl text-paper/95 whitespace-nowrap px-6 sm:px-10">
            {item}
          </span>
          <Sprout className="w-4 h-4 sm:w-5 sm:h-5 text-gold shrink-0" strokeWidth={1.5} />
        </span>
      ))}
    </div>
  );
  return (
    <div className="relative bg-ink py-5 sm:py-7 overflow-hidden border-y border-ink" data-testid="awards-marquee">
      <div className="flex w-max animate-marquee hover:[animation-play-state:paused]">
        {row(false)}
        {row(true)}
      </div>
    </div>
  );
}
